import { FiscalYear } from './fiscalYear';
import { ExecutingUnit } from './executingUnit';
import { Hhelpdesk } from './hhelpdesk';
import { PayrollType } from './payroll-type';
import { EmployeeType } from './employeeType';
import { FundingSource } from './funding-source';
import { Employee } from './employee';
import { CostCenter } from './costCenter';
import { JobTitle } from './jobTitle';
import { EmployerContribution } from './employerContribution';
import { PayScale } from './pay-scale';

export class PayrollResult {
    constructor(
        public id?: number,
        public grossAmount?: number,
        public totalIncome?: number,
        public totalDeductions?: number,
        public contractAmount?: number,
        public sctrPercentage?: number,
        public isEssaludVida?: boolean,
        public incomeTaxAmount?: number,
        public minimumWage?: number,
        public accountNumber?: string,
        public isEps?: boolean,
        public ppsTotal?: number,
        public npsTotal?: number,
        public ecsTotal?: number,
        public workingDays?: number,
        public workedDays?: number,
        public notWorkedDays?: number,
        public subsidizedDays?: number,
        public ordinaryHours?: number,
        public capNumber?: string,
        public comment?: string,
        public incomeTaxDeduction?: number,
        public costCenter?: CostCenter,
        public costCenterDesignation?: CostCenter,
        public jobTitle?: JobTitle,
        public employerContribution?: EmployerContribution,
        public payScale?: PayScale,
        public employee?: Employee,
        public fiscalYear?: FiscalYear,
        public executingUnit?: ExecutingUnit,
        public month?: Hhelpdesk,
        public payrollType?: PayrollType,
        public employeeType?: EmployeeType,
        public fundingSource?: FundingSource,
        public code?: string,
        public name?: string
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/core/entities/payroll-result.ts